import React from 'react';

import classNames from 'classnames';

import { Typography, TypographyColor } from '../Typography/Typography';
import { InputWarning } from '../icons';
import { InputWarningColor } from '../icons/InputWarning/InputWarning';
import styles from './CustomErrorMessage.module.css';

export type Props = {
  className?: string;
  error: string | JSX.Element | null;
  errorColor?: CustomErrorMessageColor;
};

export enum CustomErrorMessageColor {
  Dark = 'dark',
  Default = 'default',
  Error = 'error',
  Gray = 'gray',
  Pink = 'pink',
  Warning = 'warning',
}

export const CustomErrorMessageColorValues = {
  [CustomErrorMessageColor.Dark]: {
    inputWarning: InputWarningColor.dark,
    typographyColor: TypographyColor.Primary,
  },
  [CustomErrorMessageColor.Default]: {
    inputWarning: InputWarningColor.secondary,
    typographyColor: TypographyColor.Primary,
  },
  [CustomErrorMessageColor.Error]: {
    inputWarning: InputWarningColor.primary,
    typographyColor: TypographyColor.Error,
  },
  [CustomErrorMessageColor.Warning]: {
    inputWarning: InputWarningColor.warning,
    typographyColor: TypographyColor.Warning,
  },
  [CustomErrorMessageColor.Pink]: {
    inputWarning: InputWarningColor.pink,
    typographyColor: TypographyColor.Pink,
  },
  [CustomErrorMessageColor.Gray]: {
    inputWarning: InputWarningColor.secondary,
    typographyColor: TypographyColor.Quinary,
  },
};

export const CustomErrorMessage = React.memo((props: Props) => {
  const {
    error,
    className,
    errorColor = CustomErrorMessageColor.Default,
  } = props;

  return (
    <div className={classNames(
      styles.container,
      className,
    )}>
      <InputWarning
        color={CustomErrorMessageColorValues[errorColor].inputWarning}
        width={20}
        height={20}
        className={styles.icon}
      />

      <Typography
        variant='bodySubText1'
        color={CustomErrorMessageColorValues[errorColor].typographyColor}
      >
        {error}
      </Typography>
    </div>
  );
});

CustomErrorMessage.displayName = 'CustomErrorMessage';
